import { SetAnchorElAction } from './typings'

export const setAnchorElActionCreator = (
  payload: HTMLElement | null,
): SetAnchorElAction => ({
  type: 'activitySummary/setAnchorEl',
  payload,
})
